import SimpleSelectFilter from '../../../../../../../components/simple-select-filter';

const FilterHotel = ({ data }) => (
  <SimpleSelectFilter
    data={data}
    mapOptionRender={({ id, name }) => (
      <option key={id} value={id}>
        {name}
      </option>
    )}
    name='hotel'
  />
);

export default FilterHotel;
